(ns app.front.view.audit-log.forms.subs
  (:require [core.front.operation-registry :as operation-registry]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::start
  (fn [{:keys [db]} [_ workspace-id]]
    {:db (assoc db ::history {:workspace-id workspace-id :forms [] :pages {}})
     :fx [[:dispatch [::fetch-forms workspace-id]]]}))

(rf/reg-event-db ::stop
  (fn [db _] (dissoc db ::history)))

(defn- request-current? [db workspace-id path operation-id]
  (and (= workspace-id (get-in db [::history :workspace-id]))
       (= operation-id (get-in db (conj path :operation-id)))
       (operation-registry/operation db operation-id)))

(rf/reg-event-fx ::fetch-forms
  (fn [{:keys [db]} [_ workspace-id]]
    (let [history (::history db)]
      (when (and (= workspace-id (:workspace-id history))
                 (not (operation-registry/operation db (:operation-id history))))
        (let [operation-id (random-uuid)]
          {:db (update db ::history assoc :operation-id operation-id :request-succeeded? false)
           :fx [[:dispatch
                 [:comm/command-monitored
                  {:command      :workspace/form-history-forms
                   :operation-id operation-id
                   :method       :get
                   :data         {:workspace-id workspace-id}
                   :on-success   [::fetch-forms.success workspace-id operation-id]}]]]})))))

(rf/reg-event-fx ::fetch-form-history
  (fn [{:keys [db]} [_ workspace-id form-id]]
    (let [history                                      (::history db)
          path                                         [::history :pages form-id]
          {:keys [operation-id basis-t next-before-t]} (get-in db path)]
      (when (and (= workspace-id (:workspace-id history))
                 (some #(= form-id (:form-id %)) (:forms history))
                 (not (operation-registry/operation db operation-id))
                 (or (nil? basis-t) next-before-t))
        (let [operation-id (random-uuid)]
          {:db (update-in db path assoc :operation-id operation-id :request-succeeded? false)
           :fx [[:dispatch
                 [:comm/command-monitored
                  {:command      :workspace/form-history
                   :operation-id operation-id
                   :method       :get
                   :data         (p/assoc-if {:workspace-id workspace-id :form-id form-id :limit 50}
                                             :basis-t basis-t :before-t next-before-t)
                   :on-success   [::fetch-form-history.success workspace-id form-id operation-id]}]]]})))))

(rf/reg-event-db ::fetch-forms.success
  (fn [db [_ workspace-id operation-id _status {:keys [forms]}]]
    (if (request-current? db workspace-id [::history] operation-id)
      (update db ::history assoc :forms forms :request-succeeded? true)
      db)))

(rf/reg-event-db ::fetch-form-history.success
  (fn [db [_ workspace-id form-id operation-id _status
           {:keys [basis-t next-before-t transactions can-reveal-personal-id?]}]]
    (let [path [::history :pages form-id]]
      (if (request-current? db workspace-id path operation-id)
        (update-in db path #(cond-> (-> %
                                        (assoc :basis-t basis-t :next-before-t next-before-t :request-succeeded? true
                                               :can-reveal-personal-id? can-reveal-personal-id?)
                                        (update :transactions (fnil into []) transactions))
                              (not can-reveal-personal-id?) (dissoc :revealed-values)))
        db))))

(rf/reg-event-fx ::reveal-personal-id
  (fn [{:keys [db]} [_ workspace-id form-id reference]]
    (let [history  (::history db)
          page     (get-in history [:pages form-id])
          path     [::history :pages form-id :revealed-values reference]
          revealed (get-in db path)]
      (when (and (= workspace-id (:workspace-id history))
                 (:can-reveal-personal-id? page)
                 (not (contains? revealed :value))
                 (not (operation-registry/operation db (:operation-id revealed))))
        (let [operation-id (random-uuid)]
          {:db (assoc-in db path {:operation-id operation-id})
           :fx [[:dispatch
                 [:comm/command-monitored
                  {:command      :workspace/reveal-form-history-personal-id
                   :method       :get
                   :operation-id operation-id
                   :data         (merge {:workspace-id workspace-id :form-id form-id} reference)
                   :on-success   [::reveal-personal-id.success workspace-id form-id reference operation-id]}]]]})))))

(rf/reg-event-db ::reveal-personal-id.success
  (fn [db [_ workspace-id form-id reference operation-id _status {:keys [value]}]]
    (let [path [::history :pages form-id :revealed-values reference]]
      (if (request-current? db workspace-id path operation-id)
        (assoc-in db (conj path :value) value)
        db))))

(rf/reg-event-fx ::expand
  (fn [{:keys [db]} [_ workspace-id form-id]]
    (when-not (get-in db [::history :pages form-id :basis-t])
      {:fx [[:dispatch [::fetch-form-history workspace-id form-id]]]})))

(rf/reg-sub ::history-state :-> ::history)
(rf/reg-sub ::active-operations :-> operation-registry/active-operations)

(rf/reg-sub ::history
  :<- [::history-state]
  :<- [::active-operations]
  (fn [[history operations] _]
    (when history
      (let [with-loading       #(assoc % :loading? (contains? operations (:operation-id %)))
            with-request-state (fn [state]
                                 (let [{:keys [operation-id loading? request-succeeded?] :as state} (with-loading state)]
                                   (assoc state :failed? (boolean (and operation-id
                                                                       (not loading?)
                                                                       (not request-succeeded?))))))]
        (-> history
            with-request-state
            (update :pages #(p/map-vals (fn [page]
                                          (-> page
                                              with-request-state
                                              (update :revealed-values (partial p/map-vals with-loading)))) %)))))))
